// src/pages/auth/OIDCCallback.js
import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { oidcAuthentication } from '../../redux/auth/actions';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { Spinner } from 'reactstrap';
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const OIDCCallback = ({oidcAuthentication, error }) => {

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const searchParams = new URLSearchParams(window.location.search);
        const code = searchParams.get('code');

        console.log('OIDCCallback code', code);
        if (code) {
            oidcAuthentication(code, {
                callbackOnSuccess: () => {
                    // Redirect to dashboard or saved next path after successful authentication
                    console.log('OIDCCallback returned successfully.');

                    window.location.href = process.env.PUBLIC_URL + '/my-summary';
                },
                callbackOnFailure: (error) => {
                    console.error('OIDC Authentication failed:', error);


                }
            });
        } else {
            // No code found in URL
            //<Redirect§z to={{ pathname: process.env.PUBLIC_URL + '/'}} /> //    navigate('/login');
            window.location.href = process.env.PUBLIC_URL + '/';
        }
    }, [oidcAuthentication]);

    return (
        <React.Fragment>
            <Row className="justify-content-center">
                <Col xl={4} lg={5} md={6} sm={12}>
                    <Card>
                        <CardBody className="p-4">
                            <div className="text-center mb-4">
                                <h4 className="text-uppercase mt-0">OIDC Authentication</h4>
                            </div>

                            {loading ? (
                                <div className="text-center">
                                    <Spinner type="grow" color="primary" />
                                    <p className="mt-2">Authenticating...</p>
                                </div>
                            ) : error ? (
                                <div className="text-center text-danger">
                                    <p>Authentication failed: {error}</p>
                                </div>
                            ) : null}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    );
};

const mapStateToProps = state => {
    return {
        loading: state.Auth.loading,
        error: state.Auth.error
    };
};

export default connect(mapStateToProps, { oidcAuthentication })(OIDCCallback);